<template>
	<div id="Main">
		<div class="imgbox">
			<van-image width="60%" fit="contain" :src="require('../assets/images/service/cardtisp.png')" />
			<div class="title">
				<p class="p1">提示</p>
				<p class="p2">{{text}}</p>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				text:''
			}
		},
		mounted() {
			this.text = this.$route.query.text
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		background-color: #f2f9ff;
		min-height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		.submit {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin-top: 8rem;
			&:last-child{
				margin-top: 2rem;
				margin-bottom: 1rem;
				background-color: transparent;
				color: #fa6b6b;
				border: 1px solid #fa6b6b;
			}
		}


		.title {
			margin: 1.5rem auto;
			width: 60%;
			.p1 {
				font-weight: bold;
				color: #161616;
				font-size: 1.8rem;
				line-height: 2.5rem;
			}

			.p2 {
				color: #999999;
				font-size: 1.4rem;
				line-height: 2rem;
			}
		}

		.bor0 {
			border-bottom: 0;
		}

	}
</style>
